<script setup lang="ts">
import {toRef, useAttrs} from 'vue'
import type {RouteLocationNormalizedLoaded} from 'vue-router'
import {provideLayerContext} from '@toolify/client/src/modules/routes/composables/useLayerContext'
import {RouterView} from 'vue-router'

interface Props {
  route: RouteLocationNormalizedLoaded | null
  name?: string
}

const props = withDefaults(defineProps<Props>(), {
  route: null,
  name: undefined,
})

const attrs = useAttrs()

provideLayerContext(toRef(props, 'route'))
</script>

<template>
  <RouterView v-bind="attrs" :route="props.route" :name="props.name">
    <template #default="slotProps">
      <slot v-bind="slotProps">
        <component :is="slotProps.Component" v-if="slotProps.Component"/>
      </slot>
    </template>
  </RouterView>
</template>
